import React from 'react';
import DivisorItem from "./divisor-item.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";
import CheckHasData from "../../check-has-data.jsx";
import {FaCircleInfo} from "react-icons/fa6";

const SocialMediaDetails = ({data}) => {
    return (
        <>
            <p className={`text-[16px] text-white font-bold  p-2 bg-[#ef5744] mb-0`}>
                <CheckHasData value={data.socialMedia} />
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaExternalLinkAlt size={18}/>} text={"Link"} value={data.value}/>
                <DivisorItem icon={<FaCircleInfo size={18}/>} text={"Descrição"} value={data.additionalValue}/>
            </div>
        </>
    )
};

export default SocialMediaDetails;